import { VirtualMg75Max } from "@hid/define/define"
import { deviceManager } from "@hid/device/device_manager"

export const debugNd68 = async () => {
    await deviceManager.connect(VirtualMg75Max)
    setTimeout(() => {
        //deviceManager.deviceDriver.magnet?.getKeysTravels()
        //deviceManager.deviceDriver.magnet?.syncKeysTravels()
        //deviceManager.deviceDriver.magnet?.syncKeysDeadZone()
        //deviceManager.deviceDriver.magnet?.getKeysDeadZone()

        //deviceManager.deviceDriver.magnet?.startTravels()
        deviceManager.deviceDriver.syncKeys()
    }, 100);
}
